import React from 'react';
import { ButtonGroup, Button } from '@mui/material';

export const COLLECTIONS_SELECTED_LOCATION_KEY = 'collectionsSelectedLocation';

export type CollectionsCorporateLocation = 'tampa' | 'pittsburgh';

export function getCollectionsSelectedLocation(): CollectionsCorporateLocation {
  const stored = sessionStorage.getItem(COLLECTIONS_SELECTED_LOCATION_KEY);
  if (stored === 'pittsburgh' || stored === 'tampa') return stored;
  return 'tampa';
}

/**
 * Location toggle for top navigation bar (Collections module).
 * Pittsburgh / Tampa — matches ChillerLocationToggle styling; uses dedicated session key.
 */
const CollectionsLocationToggle: React.FC = () => {
  const selectedLocation = getCollectionsSelectedLocation();

  const handleLocationChange = (location: CollectionsCorporateLocation) => {
    sessionStorage.setItem(COLLECTIONS_SELECTED_LOCATION_KEY, location);
    window.location.reload();
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span
        style={{
          fontSize: '13px',
          fontWeight: 600,
          color: '#202223',
          whiteSpace: 'nowrap',
        }}
      >
        Location:
      </span>
      <ButtonGroup size="small" variant="outlined">
        <Button
          variant={selectedLocation === 'pittsburgh' ? 'contained' : 'outlined'}
          onClick={() => handleLocationChange('pittsburgh')}
          style={{
            textTransform: 'none',
            minWidth: '90px',
          }}
        >
          Pittsburgh
        </Button>
        <Button
          variant={selectedLocation === 'tampa' ? 'contained' : 'outlined'}
          onClick={() => handleLocationChange('tampa')}
          style={{
            textTransform: 'none',
            minWidth: '90px',
          }}
        >
          Tampa
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default CollectionsLocationToggle;
